import { call, put } from 'redux-saga/effects'
import { getCandidateCalendarAvailabilities } from '../apiModules/candidateAvailabilities'
import { candidateAvailabilityEntities } from '../reducks'

export function* fetchCandidateAvailabiltyEntitiesSaga(candidateProfileId) {
  const response = yield call(getCandidateCalendarAvailabilities, candidateProfileId)
  yield put(candidateAvailabilityEntities.addCollection(response.result))
  return response
}
